import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { Permissions } from 'src/app/permissions.enum';

@Component({
  selector: 'app-dashboard-redirect',
  standalone: true,
  template: '',
})
export class DashboardRedirectComponent {
  constructor(private authService: AuthService, private router: Router) {
    const permissionRoutesMap: { [key: string]: string } = {
      [Permissions.Summary]: 'summary',
      [Permissions.ExamFolder]: 'exam-folders',
      [Permissions.FormSetup]: 'forms-setup',
      [Permissions.QuestionsAndAnswers]: 'questions-and-answers',
      [Permissions.Report]: 'reports',
      [Permissions.ExamSchedule]: 'exam-schedule',
      [Permissions.Exam]: 'exam',
      [Permissions.Settings]: 'settings',
    };

    const permissions = this.authService.getUserPermissions(); 
    const firstPermission = permissions.find(p => permissionRoutesMap[p]);

    if (firstPermission) {
      this.router.navigate(['/dashboard', permissionRoutesMap[firstPermission]]);
    } else {
      this.router.navigate(['/']); 
    }
  }
}
